let senderId: string | null = null

export function getSenderId() {
  return senderId
}

export function setSenderId(id: string | null) {
  senderId = id
}
